export default __webpack_public_path__ + "assets/phone-call.svg";